import { render, staticRenderFns } from "./ModulesMenu.vue?vue&type=template&id=97fcf8da&"
import script from "./ModulesMenu.vue?vue&type=script&lang=js&"
export * from "./ModulesMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports